import DashboardComponent from "@/components/api/DashboardComponent";
import {handleApiError} from "@/utils/VuexUtil";

const MODULE_NAME = 'dashboard'

const state = {
    isLoading: false,
    errors: null,
    result: null,
    totalPages: null
}

export const DashboardActionTypeEnum = {
    get: '['+MODULE_NAME+'] get',
};

const MutationTypeEnum = {
    getStart: '['+MODULE_NAME+'] getStart',
    getSuccess: '['+MODULE_NAME+'] getSuccess',
    getFailure: '['+MODULE_NAME+'] getFailure',
};

const getters = {
    dashboardIsLoading: (state) => state.isLoading,
    dashboardGetResult: (state) => state.result,
    dashboardGetErrors: (state) => state.errors,
}

const mutations =  {
    // Get
    [MutationTypeEnum.getStart](state) {
        state.isLoading = true
        state.result = null
        state.errors = null
    },
    [MutationTypeEnum.getSuccess](state, response) {
        state.isLoading = false
        if (response) state.result = response.result
    },
    [MutationTypeEnum.getFailure](state, response) {
        state.isLoading = false
        if (response) state.errors = response.errors
    },
}

const actions = {
    async [DashboardActionTypeEnum.get](context, request) {
        context.commit(MutationTypeEnum.getStart)
        try {
            const response = await DashboardComponent.get(request)
            context.commit(MutationTypeEnum.getSuccess, response)
            return response
        } catch (error) {
            const formattedError = handleApiError(error);
            context.commit(MutationTypeEnum.getFailure, formattedError)
            return formattedError
        }
    },

}

export default {
    state,
    getters,
    mutations,
    actions
}